<script setup>
const props = defineProps({
  number: {
    type: [Number, String],
    default: null,
  },
  text: {
    type: String,
    required: true,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
});

const hasNumber = computed(() => props.number !== null && props.number !== '');
</script>

<template>
  <div class="contents-title" :class="{ mobile: isMobile }">
    <div v-if="hasNumber" class="contents-title__badge">{{ number }}</div>
    <span class="contents-title__text">{{ text }}</span>
  </div>
</template>

<style scoped lang="scss">
.contents-title {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 24px;
  background: rgba(190, 51, 49, 0.05);

  &.mobile {
    padding: 16px 20px;
  }

  &__badge {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    background: #be3331;
    border-radius: 11px;
    color: #fff;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
  }

  &__text {
    color: #be3331;
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
}
</style>
